import Layout1 from "../layouts/backend/Layout1";

// //main
import Dashbord from "../views/backend/Main/Dashbord";

// Product
import UsersList from "../views/backend/Main/UsersList";

// icon-heroicon
import Lead from "../views/backend/Main/Lead";
import LeadeditQuote from "../views/backend/Main/LeadeditQuote";
import LeadeView from "../views/backend/Main/LeadeView";
import LeadEdit from "../views/backend/Main/LeadEdit";
import UsersEdit from "../views/backend/Main/UsersEdit";
import UsersDetail from "../views/backend/Main/UsersDetail";
import ProfileEdit from "../views/backend/App/UserManagement/ProfileEdit";
import LeadAdd from "../views/backend/Main/LeadAdd";
import UsersAdd from "../views/backend/Main/UsersAdd";
import Payment from "../views/backend/Main/Payment";
import PaymentAdd from "../views/backend/Main/PaymentAdd";
import LeadGeneratQuoteView from "../views/backend/Main/LeadGeneratQuoteView";
import ForwardersList from "../views/backend/Main/ForwardersList";
import ForwardersAdd from "../views/backend/Main/ForwardersAdd";
import ForwardersEdit from "../views/backend/Main/ForwardersEdit";
import SubaccountsList from "../views/backend/Main/SubaccountsList";
import SubaccountsEdit from "../views/backend/Main/SubaccountsEdit";
import MlmAccountsList from "../views/backend/Main/MlmAccountsList";
import MlmAccountsAdd from "../views/backend/Main/MlmAccountsAdd";
import MlmAccountsEdit from "../views/backend/Main/MlmAccountsEdit";

export const Layout1Route = [
  {
    path: "/",
    element: <Layout1 />,
    children: [
      {
        path: "/",
        element: <Dashbord />,
      },
      {
        path: "/leads",
        element: <Lead />,
      },
      {
        path: "/lead-add",
        element: <LeadAdd />,
      },
      {
        path: "/lead-edit/:leadId",
        element: <LeadEdit />,
      },
      {
        path: "/lead-edit-quote/:leadId",
        element: <LeadeditQuote />,
      },
      {
        path: "/lead-view/:leadId",
        element: <LeadeView />,
      },
      {
        path: "/lead-generat-quoted-view/:leadId",
        element: <LeadGeneratQuoteView />,
      },
      {
        path: "/users-list",
        element: <UsersList />,
      },
      {
        path: "/users-add",
        element: <UsersAdd />,
      },
      {
        path: "/users-edit/:userId",
        element: <UsersEdit />,
      },
      {
        path: "/users-detail/:userId",
        element: <UsersDetail />,
      },
      {
        path: "/payment",
        element: <Payment />,
      },
      {
        path: "/payment-add",
        element: <PaymentAdd />,
      },
      {
        path: "/profile-edit",
        element: <ProfileEdit />,
      },
      {
        path: "/forwarders-list",
        element: <ForwardersList />,
      },
      {
        path: "/forwarders-add",
        element: <ForwardersAdd />,
      },
      {
        path: "/forwarders-edit/:forwarderId",
        element: <ForwardersEdit />,
      },
      {
        path: "/subaccounts-list",
        element: <SubaccountsList />,
      },
      {
        path: "/subaccounts-edit/:subaccountId",
        element: <SubaccountsEdit />,
      },
      {
        path: "/mlm-accounts",
        element: <MlmAccountsList />,
      },
      {
        path: "/mlm-accounts-add",
        element: <MlmAccountsAdd />,
      },
      {
        path: "/mlm-accounts-edit/:id",
        element: <MlmAccountsEdit />,
      },
    ],
  },
];
